import { useDeleteStore } from '../../hooks';
import { CrawlerDeleteModalView } from '../../components/CrawlerDeleteModalView';

export const CrawlerDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <CrawlerDeleteModalView {...deleteStore} />;
};
